import * as BABYLON from "babylonjs";
import 'babylonjs-inspector';
import LoaderManager from "./LoaderManager";


export default class StudioSceneManager {
  constructor(game) {
    this.game = game;
    //Main Props
    this.scene = null;
    this.studioGui = null;
    this.mainCamera = null;
    this.pipline = null;

    this.floors = [];
    this.selectedFloorId = 9;

    this.selecedFloor=null;
  }

  //#region  MainSceneProperties
  createScene(onLoad) {
    //Create Scene
    this.scene = new BABYLON.Scene(this.game.engine);
    this.scene.clearColor = new BABYLON.Color4(0, 0, 0, 0.000001);
    // this.scene.imageProcessingConfiguration.colorCurvesEnabled = true;
    // this.scene.imageProcessingConfiguration.colorCurves = new BABYLON.ColorCurves();
    // this.scene.imageProcessingConfiguration.colorCurves.globalSaturation = 0;
    this.scene.imageProcessingConfiguration.contrast = 1;
    this.scene.imageProcessingConfiguration.exposure = 1;
    this.scene.imageProcessingConfiguration.vignetteEnabled = true;
    this.scene.imageProcessingConfiguration.toneMappingEnabled = true;
    this.scene.imageProcessingConfiguration.toneMappingType = BABYLON.ImageProcessingConfiguration.TONEMAPPING_STANDARD;
    
    // this.scene.debugLayer.show();


    //init
    this.createCamera();
    this.setUpEnvironMent();  

    ///onFinish
    const onFinish = () => {
      console.log("Finish loading Model !");
      this.shadowGenerator.recreateShadowMap();
      onLoad()
    };

    //create LoadManager instance
    this.loaderManager = new LoaderManager(this);
    this.loaderManager.loadAvatar(onFinish);

    return this.scene;
  }
  createCamera() {
    console.log("createCamera")

    this.mainCamera = new BABYLON.ArcRotateCamera(
      "ArcCamera",
      1.55,
      1.5,
      60,
      new BABYLON.Vector3(0, 13, 0),
      this.scene
    );
    this.mainCamera.attachControl();

    this.mainCamera.panningDistanceLimit = .0001;

    this.mainCamera.lowerRadiusLimit = 50;
    this.mainCamera.upperRadiusLimit = 100;

    this.mainCamera.lowerBetaLimit = 0.85;
    this.mainCamera.upperBetaLimit = 1.5;

    this.mainCamera.minZ = 0.2;
    this.mainCamera.wheelPrecision = 3;
    this.mainCamera.useBouncingBehavior = true;
    // // this.mainCamera.framingBehavior.radiusScale = 4;
    // // this.mainCamera.framingBehavior.framingTime = 4000;

    this.floorCamera = new BABYLON.ArcRotateCamera(
      "floorCamera",
      1.55,
      1.5,
      55,
      new BABYLON.Vector3(0, 15, 0),
      this.scene
    );
  }
  setUpEnvironMent() {
    // let hemiLight = new BABYLON.HemisphericLight(
    //   "HemiLight",
    //   new BABYLON.Vector3(0.3, 1, -0.3),
    //   this.scene
    // );
    // hemiLight.intensity = 1;

 	// light1
  //  var dirLight = new BABYLON.DirectionalLight("dir01", new BABYLON.Vector3(-1, -2, -1), this.scene);
  //  dirLight.position = new BABYLON.Vector3(20, 40, 20);
  //  dirLight.intensity = 0.5;
  //  dirLight.shadowEnabled=true;

  // const dirLight = new BABYLON.SpotLight("sds", new BABYLON.Vector3(16.423, 27.733, 17.622), new BABYLON.Vector3(-1, -2, -1), Math.PI / 2, 10, this.scene)
  //    dirLight.shadowEnabled=true;

  const dirLight = new BABYLON.DirectionalLight("light1", new BABYLON.Vector3(-5, -6, -2), this.scene);
  dirLight.position = new BABYLON.Vector3(20, 60, 20);
  dirLight.shadowMinZ = 0;
  dirLight.shadowMaxZ = 1500;
  dirLight.intensity = 3;
  

    this.alphaMaterial = new BABYLON.StandardMaterial("alphaMat", this.scene);
    this.alphaMaterial.alpha = 0;

    // ShadowGenerator
    this.shadowGenerator = new BABYLON.ShadowGenerator(2064, dirLight);
    // this.shadowGenerator.useBlurExponentialShadowMap = true;
    // this.shadowGenerator.useExponentialShadowMap = true;
    // this.shadowGenerator.useContactHardeningShadow = true;
    // this.shadowGenerator.bias = 0.01;
    // this.shadowGenerator.normalBias= 0.05;
    // this.shadowGenerator.contactHardeningLightSizeUVRatio = 0.08;


  //   var helper = this.scene.createDefaultEnvironment({
  //     skyboxSize: 500,
  //     groundShadowLevel: 0.5,
  // });       
  // helper.setMainColor(BABYLON.Color3.Gray());
  // this.scene.environmentTexture.lodGenerationScale = 0.6;
  
  // url(https://imgur.com/34b8c97f-33bd-49af-a102-859afccee2ba)
    // this.shadowGenerator.filteringQuality = BABYLON.ShadowGenerator.QUALITY_HIGH;
    this.shadowGenerator.blurScale = 64;
    this.shadowGenerator.bias = 0.0010;
    this.shadowGenerator.normalBias = 0.010;
    this.shadowGenerator.filter = 6;
    this.shadowGenerator.filteringQuality = 0;

    // this.shadowGenerator.setDarkness(.1);
    // dirLight.intensity = 1;
    // dirLight.shadowMinZ = 0;
    // dirLight.shadowMaxZ = 700;

//     const gizmoManager = new BABYLON.GizmoManager(this.scene);
//     gizmoManager.positionGizmoEnabled = true;
// gizmoManager.rotationGizmoEnabled = true;
// // gizmoManager.scaleGizmoEnabled = true;
// gizmoManager.attachableMeshes = [dirLight];
//     gizmoManager.attachToMesh(dirLight);

    // Our built-in 'ground' shape. Params: name, width, depth, subdivs, scene
    // let ground = BABYLON.Mesh.CreateGround("ground1", 85, 85, 85  * 2, this.scene);
    // ground.receiveShadows = true;
    // this.shadowGenerator.addShadowCaster(ground);

    
    // Create and tweak the background material.
    var backgroundMaterial = new BABYLON.BackgroundMaterial(
      "backgroundMaterial",
      this.scene
    );
    backgroundMaterial.diffuseTexture = new BABYLON.Texture(
      "./Textuers/scene/backgroundGround.png",
      this.scene
    );
    backgroundMaterial.diffuseTexture.hasAlpha = true;
    backgroundMaterial.opacityFresnel = false;
    backgroundMaterial.shadowLevel = 1;
    backgroundMaterial.alpha = 0.65;

    //Create CubicTexture
    let skyboxCubecTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(
      "./environment/environment.env",
      this.scene
    );
    this.scene.environmentTexture = skyboxCubecTexture;
    this.scene.environmentTexture.level = 1.34;
    this.scene.environmentTexture.rotationY = 5.443;
    this.scene.environmentIntensity = 1;


    //Mirror
    this.mirror = new BABYLON.MirrorTexture("mirror", 512, this.scene);
    this.mirror.mirrorPlane = new BABYLON.Plane(0, -1, 0, 0);
    this.mirror.adaptiveBlurKernel = 32;
    // this.Groundmirror.mirrorPlane = new BABYLON.Plane(0, -.69, -0, -1);
    backgroundMaterial.reflectionTexture = this.mirror;
    backgroundMaterial.reflectionFresnel = true;
    backgroundMaterial.reflectionStandardFresnelWeight = 0.85;
    backgroundMaterial.reflectionTexture.level = .55;
    // ground.material = backgroundMaterial;
  }
  //#endregion


  //#region UserInput (Mouse)
  onPointerDown(ev) { }
  onPointerUp(ev) { }
  onPointerMove(ev) { }
  //#endregion

  //#region Actions
  activeNormalView(){
    this.floorCamera.detachControl();
    this.scene.activeCamera = this.mainCamera;
    this.mainCamera.attachControl();

    for (let i = 0; i < this.floors.length; i++) {
      this.floors[i].setEnabled(true);         
    };
    this.resetHiglightFloors();
  }
  activeFloorsView() {

    this.resetHiglightFloors();
    //copy camera view

    this.floorCamera.alpha = 1.55;
    this.floorCamera.beta =  1.5;
    this.floorCamera.radius = 55;
    this.floorCamera.target = new BABYLON.Vector3(0, 15, 0);
    this.floorCamera.lowerBetaLimit = 0;
    this.floorCamera.upperBetaLimit = 4;
    this.floorCamera.lowerRadiusLimit = 0;
    this.floorCamera.upperRadiusLimit = 100; 

    //   this.floorCamera.alpha = this.mainCamera.alpha;
    // this.floorCamera.beta = this.mainCamera.beta;
    // this.floorCamera.radius = this.mainCamera.radius;
    // this.floorCamera.target = this.mainCamera.target.clone();

    //disable mainCamera
    this.mainCamera.detachControl();
    this.scene.activeCamera = this.floorCamera;
    this.selectedFloorId = 9;

    //animate new camera
    this.assignCameraAnimation(this.floorCamera, ()=>{
      this.floorCamera.attachControl();
      const targetRadius = 40.00;
      this.floorCamera.lowerBetaLimit = this.floorCamera.beta;
      this.floorCamera.upperBetaLimit = this.floorCamera.beta + 0.35;
      this.floorCamera.lowerRadiusLimit = targetRadius;
      this.floorCamera.upperRadiusLimit = targetRadius + 5; 
      this.floors[this.floors.length - 1].setEnabled(false); 
    });
  }
  activeAvailability(){
    this.activeNormalView();
  }
  highlightFloorId(floorId) {
    this.floors[floorId].getChildMeshes().forEach((child)=>{
      if(!child.name.includes("Glass")){
        let targetMat = null;
        if(this.floors[floorId].cloned){
          targetMat = child.material;
        }else{
          targetMat = child.material.clone("cloned");
          child.material = targetMat;
        }
        targetMat.albedoColor = new BABYLON.Color3(243/255,210/255,161/255, 1).toLinearSpace();
        targetMat.emissiveColor = new BABYLON.Color3(243/255,210/255,161/255, 1).toLinearSpace();
      }
    });
    this.selecedFloor =this.floors[floorId];
  }
  unCheckHighlightFloorId(floorId) {
    this.floors[floorId].getChildMeshes().forEach((mesh)=>{
      if(mesh && mesh.material){
        mesh.material.albedoColor =  BABYLON.Color3.White();
        mesh.material.emissiveColor =  BABYLON.Color3.Black();
        // if(mesh.material.albedoTexture.level){
        //   mesh.material.albedoTexture.level = 1;
        // }
      }
    });
    this.selecedFloor =this.floors[floorId];
  }
  resetHiglightFloors(){
    this.floors.forEach((floor)=>{
      floor.getChildMeshes().forEach((mesh)=>{
        if(mesh && mesh.material){
          mesh.material.albedoColor =  BABYLON.Color3.White();
          mesh.material.emissiveColor =  BABYLON.Color3.Black();
          // if(mesh.material.albedoTexture.level){
          //   mesh.material.albedoTexture.level = 1;
          // }
        }
      });
    })
  }
  navigateToFloorId(floorId) {
    let radiusOffset = (this.selectedFloorId - floorId) * 3.5;
    const target = new BABYLON.Vector3(
      this.floorCamera.target.x,
      this.floorCamera.target.y - radiusOffset,
      this.floorCamera.target.z,
    );
    if (this.selectedFloorId < floorId) { //show
      let currentIndex =this.selectedFloorId;
      let targetIndex =floorId
      this.assignTargetAnimation(this.floorCamera,target,()=>{
        for (let i = currentIndex; i <= targetIndex; i++) {
          this.floors[i].setEnabled(true);         
        }
      });

    } else {//hide
      for (let i = this.floors.length - 1; i > floorId; i--) {
        this.floors[i].setEnabled(false);         
      }
      this.assignTargetAnimation(this.floorCamera,target,()=>{
      });
    }
    this.selectedFloorId = floorId;
 
   
  }

  simplifyRadians(radians) {
    const simplifiedRadians = radians % (2 * Math.PI);

    return simplifiedRadians < 0
        ? simplifiedRadians + BABYLON.Tools.ToRadians(360)
        : simplifiedRadians;
  }
  onSpotClick(data, type){
    if(type === "iframe"){
      this.handlers.onIframeSpotClick(data); //hide all components ui
    }else{
      this.handlers.onNormalSpotClick(data); //hide all components ui
    }
  }
  //#endregion


  //#region Animations
  assignScaleAnimation(targetObj, onFinish) {
    targetObj.animations = [];
    var scaleAnimation = new BABYLON.Animation(
      "scaleAnimation",
      "scaling",
      300,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    );

    var keys = [];

    keys.push({
      frame: 0,
      value: targetObj.scaling.clone(),
    });

    keys.push({
      frame: 50,
      value: new BABYLON.Vector3(1 * 1.4, 1 * 1.4, -1 * 1.4),
    });

    keys.push({
      frame: 100,
      value: new BABYLON.Vector3(1, 1, -1),
    });

    scaleAnimation.setKeys(keys);
    targetObj.animations.push(scaleAnimation);
    this.scene.beginAnimation(targetObj, 0, 100, false, 1, () => {
      if (onFinish) onFinish();
    });
  }
  assignCameraAnimation(targetCamera, onFinish) {
    targetCamera.animations = [];
    const targetBeta = 0.35, targetAlpha = 2.85, targetRadius = 55.00, target = new BABYLON.Vector3(-1, 30, -1);
    var betaAnimation = new BABYLON.Animation(
      "scaleAnimation",
      "beta",
      300,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    );
    betaAnimation.setKeys(
      [
        {
          frame: 0,
          value: this.simplifyRadians(targetCamera.beta),
        },
        {
          frame: 100,
          value: targetBeta,
        }
      ]
    );
    var alphaAnimation = new BABYLON.Animation(
      "alphaAnimation",
      "alpha",
      300,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    );
    alphaAnimation.setKeys(
      [
        {
          frame: 0,
          value: this.simplifyRadians(targetCamera.alpha),
        },
        {
          frame: 100,
          value: targetAlpha,
        }
      ]
    );
    var radiusAnimation = new BABYLON.Animation(
      "radiusAnimation",
      "radius",
      300,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    );
    radiusAnimation.setKeys(
      [
        {
          frame: 0,
          value: targetCamera.radius,
        },
        {
          frame: 100,
          value: targetRadius,
        }
      ]
    );

    var targetAnimation = new BABYLON.Animation(
      "targetAnimation",
      "target",
      300,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    );
    targetAnimation.setKeys(
      [
        {
          frame: 0,
          value: targetCamera.target.clone(),
        },
        {
          frame: 100,
          value: target,
        }
      ]
    );
    
    var ease = new BABYLON.CubicEase();
    ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEIN);

    betaAnimation.setEasingFunction(ease)
    alphaAnimation.setEasingFunction(ease)
    radiusAnimation.setEasingFunction(ease)
    targetAnimation.setEasingFunction(ease)

    var animationGroup = new BABYLON.AnimationGroup("CameraAnimationsGroup");
    animationGroup.addTargetedAnimation(betaAnimation, targetCamera);
    animationGroup.addTargetedAnimation(alphaAnimation, targetCamera);
    animationGroup.addTargetedAnimation(radiusAnimation, targetCamera);
    animationGroup.addTargetedAnimation(targetAnimation, targetCamera);
    animationGroup.normalize(0, 100);
    animationGroup.speedRatio = 0.35;
    animationGroup.onAnimationEndObservable.add(() => {
      console.log("finish");
      onFinish();
      // mesh2.material = redMaterial;
    });
    animationGroup.play();
    // targetCamera.animations.push(scaleAnimation);
    // this.scene.beginAnimation(targetCamera, 0, 100, false, 1, () => {
    //   if (onFinish) onFinish();
    // });
  }
  assignTargetAnimation(targetObj, target, onFinish) {
    targetObj.animations = [];
    var targetAnimation = new BABYLON.Animation(
      "targetAnimation",
      "target",
      300,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    );
    targetAnimation.setKeys(
      [
        {
          frame: 0,
          value: targetObj.target.clone(),
        },
        {
          frame: 100,
          value: target,
        }
      ]
    );
    var ease = new BABYLON.CubicEase();
    ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
    targetAnimation.setEasingFunction(ease)
    targetObj.animations.push(targetAnimation);

    this.scene.beginAnimation(targetObj, 0, 100, false, .5, () => {
      if (onFinish) onFinish();
    },);
  }
  //#endregion
}
